import React from 'react';
import { Redirect } from 'react-router-dom';

import { useAdminAuth } from '../hooks/use-admin-auth.hook';

interface AuthenticatedAdminGuardProps {
  children: React.ReactNode;
}

const AuthenticatedAdminGuard: React.FC<AuthenticatedAdminGuardProps> = ({ children }) => {
  const { isAuthenticated, isAdmin } = useAdminAuth();

  if (!isAuthenticated) return <Redirect to="/login" />;
  if (!isAdmin) return <Redirect to="/" />;

  return <>{children}</>;
};

export default AuthenticatedAdminGuard;
